<template>
  <div>
    <UserManagementModal
      ref="userManagementModal"
      @refresh="refresh"
    />
    <UserManagementEditModal
      ref="userManagementEditModal"
      @refresh="refresh"
    />
    <DisableUserModal
      ref="disableUserModal"
      @refresh="refresh"
    />
    <FirstAccessModal
      v-if="showWarning"
      @close="showWarning = false"
    />

    <div>
      <div class="profile-management__header">
        <h2 class="profile-management__header__h2">
          Minha Equipe
        </h2>
        <button
          id="newTeamMember"
          class="btn btn-primary btn-new"
          @click="openUserModal"
        >
          <img src="/static/images/icon-plus.svg">
          Novo membro
        </button>
      </div>
      <loading v-if="loadingStatus === 'LOADING'" />
      <div v-else>
        <div
          v-if="teamList && teamList.length > 0"
          class="profile-management__table"
        >
          <div class="table-header">
            <ul>
              <li class="--name">
                Nome
              </li>
              <li class="--email">
                Email
              </li>
              <li class="--role">
                Tipo de Perfil
              </li>
              <li class="--actions" />
            </ul>
          </div>
          <div class="table-body">
            <div
              v-for="member in teamList"
              :key="member.id"
              class="card"
              :class="{ '--disabled': !member.status }"
            >
              <p class="--name">
                {{ member.name }}
              </p>
              <p class="--email">
                {{ member.username }}
              </p>
              <p class="--role">
                <span :class="{ '--disabled-role': !member.status }">{{ insertPortugueseLabel(member.role)
                }}</span>
              </p>
              <div class="--actions">
                <div class="box-actions">
                  <div
                    v-if="checkEdit(member)"
                    class="status-icon icon-edit-alt"
                    @click="openEditUserModal(member)"
                  />
                  <div
                    v-if="member.role !== 'SUPER_ADMIN' && member.status"
                    class="status-icon icon-delete-alt"
                    @click="disableUser(member)"
                  />
                  <div
                    v-if="!member.status"
                    class="status-icon icon-edit-alt"
                    @click="openEnableUserModal(member)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-else
          class="empty-list"
        >
          <img
            src="/static/images/perfil-de-acesso/empty-list.svg"
            alt="Lista Vazia de Membros da Equipe"
          >
          Ainda não há membros na sua equipe
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Moment from 'moment'

import UserManagementModal from '@/components/ProfileManagement/components/UserManagementModal.vue'
import UserManagementEditModal from '@/components/ProfileManagement/components/UserManagementEditModal.vue'
import DisableUserModal from '@/components/ProfileManagement/components/DisableUserModal.vue'
import FirstAccessModal from '@/components/ProfileManagement/components/FirstAccessModal.vue'

export default {
  name: 'ProfileManagementView',
  components: {
    UserManagementModal,
    UserManagementEditModal,
    DisableUserModal,
    FirstAccessModal
  },
  data() {
    return {
      showWarning: true
    }
  },
  computed: {
    ...mapGetters(['profile', 'teamList', 'loadingStatus', 'actualMember'])
  },
  watch: {
    teamList(newList) {
      console.info(newList)
    },
  },
  mounted() {
    this.getTeamList()
  },
  methods: {
    ...mapActions(['getTeamList']),
    openUserModal() {
      this.$refs.userManagementModal.openUserManagementModal()
    },
    openEditUserModal(member) {
      const clonedMember = { ...member }
      if (clonedMember.birthday) {
        const dateObj = Moment(clonedMember.birthday, [Moment.ISO_8601, 'DD/MM/YYYY'], true)
        clonedMember.birthday = dateObj.isValid() ? dateObj.format('DD/MM/YYYY') : ''
      }
      this.$refs.userManagementEditModal.openUserManagementEditModal(clonedMember, false)
    },
    openEnableUserModal(member) {
      member.birthday = Moment(member.birthday).format('DD/MM/YYYY')
      this.$refs.userManagementEditModal.openUserManagementEditModal(member, true)
    },
    checkEdit(member) {
      if (member.role === 'SUPER_ADMIN') {
        return member.role === this.actualMember.role
      } else {
        return member.status
      }
    },
    disableUser(member) {
      this.$refs.disableUserModal.openDisableUserModal(member)
    },
    insertPortugueseLabel(role) {
      const rolesMap = {
        OPERATOR: 'OPERADOR',
        FINANCIAL: 'FINANCEIRO',
        ADMINISTRATOR: 'ADMINISTRADOR',
        PATERNITY: 'PATERNIDADE',
        SUPER_ADMIN: 'SUPER ADMIN'
      }
      return rolesMap[role] || role
    },
    refresh() {
      this.getTeamList()
    }
  },
}
</script>

<style lang="scss">
.profile-management {
  min-height: 100vh;
  padding-top: 60px !important;
  margin-top: 3em;
  display: flex;
  justify-content: center;
  font-family: 'Exo 2' !important;

  &__menu {
    width: 230px;
  }

  &__account {
    display: flex;
    align-items: center;
    margin-bottom: 24px;

    span {
      margin-left: 8px;
      flex-shrink: 1;
      font-size: 14px;
      color: #363636;
      font-weight: 600;
    }

    svg,
    i {
      width: 40px;
      height: 40px;
      min-width: 40px;
      min-height: 40px;
    }
  }

  &__content {
    flex: 1 1 auto;
    max-width: 700px;
    margin-left: 64px;

    .empty-list {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-top: 110px;
      color: #818181;
      font-size: 23px;

      img {
        margin-bottom: 24px;
      }
    }
  }

  &__list {
    li {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 16px;
      border-radius: 6px;
      height: 41px;
      font-weight: 600;
      color: #595959;
      cursor: pointer;

      &.active {
        background: #fcf2f8;
        color: #7f1a54;

        i path {
          fill: #7f1a54;
        }
      }

      i {
        width: 16px;
        height: 16px;
        min-width: 16px;
        min-height: 16px;
        margin: 0;
      }
    }
  }

  &__content-wrapper {
    display: flex;
    flex-direction: column;
  }

  &__table {
    margin-top: 30px;

    .table-header {
      padding: 6px 27px;

      ul {
        display: flex;
        align-items: center;

        li {
          margin: 0;
          font-weight: 600;
          font-size: 11.11px;
          text-transform: uppercase;
          color: #999999;
        }
      }
    }

    .table-body {
      .card {
        display: flex;
        align-items: center;
        font-weight: 400;
        height: 58px;
        padding: 0 24px 0 18px;
        border-left: 6px #fff solid;
        margin-bottom: 8px;
        transition: all ease 0.3s;
				background-color: #fff;

        &:hover {
          border-color: #7f1a54;

          .box-actions {
            display: flex !important;
          }
        }

        p {
          font-size: 14px;
          color: #363636;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          margin-right: 4px;
        }

        .--name {
          font-weight: 600;
        }

        .--role {
          span {
            color: #fff;
            font-size: 11.11px;
            background: #76d692;
            border-radius: 2px;
            text-transform: uppercase;
            padding: 1px 8px;
            margin: 0;
            font-weight: 600;
            display: flex;
            max-width: 100px;
            align-items: center;
            justify-content: center;
          }
        }

        .--actions {
          .box-actions {
            display: none;
            justify-content: center;
            align-items: center;
          }

          .status-icon {
            margin: 0 3px;
          }
        }
      }
    }

    .--name,
    .--email {
      flex: 2;
    }

    .--role,
    .--actions {
      flex: 1;
    }
    
    .--disabled {
      opacity: .7;
    }

    .--disabled-role {
      background: #818181 !important;
    }
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #6d6d6d;

		&__h2 {
			font-size: 18px;
			letter-spacing: 0.1px;
			text-align: left;
			color: #7f1a54;
			font-weight: 600;
			text-transform: uppercase;
			align-self: self-start;
		}

    .btn {
      display: flex;
      align-items: center;
      padding: 11px 20px;
      font-size: 13.33px;
      font-family: 'Exo 2';
      font-weight: 600;
      text-transform: uppercase;
      color: #ffffff;

      img {
        margin-right: 8px;
      }
    }
  }
  .card {
    padding: 20px 27px;
    background-color: #fff;
    border-radius: 6px;

    h2 {
      font-size: 12px;
      letter-spacing: 0.1px;
      text-align: left;
      color: #7f1a54;
      font-weight: 600;
      text-transform: uppercase;
    }

    span {
      font-size: 12px;
      margin-top: 16px;
    }

    p {
      font-size: 13.33px;
    }
  }

  .loading_container {
    height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;

    #loading {
      width: 100px;
    }

    .loading {
      width: 60px;
      height: 60px;
      border-radius: 30px;
    }
  }
}
</style>